import { wait } from "@zirp/util";
import { useApi } from "../useApi";
import { useFetchProfile } from "./useFetchProfile";
import { useAuth } from "./useAuth";
import type { User } from "@zirp/client";

export const useEmailLogin = () => {
  const loading = useState<boolean>("emailLogin:loading", () => false);
  const error = useState<string | null>("emailLogin:error", () => null);
  const api = useApi();
  const { token } = useAuth();
  const { fetchUserProfile } = useFetchProfile();

  const emailLogin = async (email: string, password: string) => {
    try {
      error.value = null;
      loading.value = true;

      const base = api.request.config.BASE;
      const { result: { user, token: t } } = (await (await fetch(`${base}/v1/auth/login`, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ email, password }) })).json()) as { result: { user: User, token?: string } };
      if (user.emailVerified) {
        token.value = t;
        await wait(200)
        await fetchUserProfile();
        return navigateTo("/onboarding");
      }
      navigateTo({ path: "/onboarding/verify-email", query: { id: user.id, email: user.email } });
    } catch (err) {
      error.value = "Failed to complete email login";
      console.error("Login error:", err);
    } finally {
      loading.value = false;
    }
  };

  return {
    emailLogin,
    loading,
    error,
  };
};
